<section class="page-hero">
  <div class="hero-copy">
    <p class="eyebrow">Who should join</p>
    <h1>Built for people already trusted by boaters.</h1>
    <p class="lede">If your audience needs better vessel maintenance organization, YachtApp can fit naturally into your
      recommendations.</p>
  </div>
</section>
<section class="content-section audience-grid">
  <article>
    <h3>Sailing schools</h3>
    <p>Help students continue good maintenance habits after training.</p>
  </article>
  <article>
    <h3>Charter companies</h3>
    <p>Recommend structured maintenance records to owners and fleet customers.</p>
  </article>
  <article>
    <h3>Marina operators</h3>
    <p>Offer tenants a practical tool for upkeep reminders and vessel documentation.</p>
  </article>
  <article>
    <h3>Yacht brokers</h3>
    <p>Add value before and after sale with organized ownership workflows.</p>
  </article>
  <article>
    <h3>Boat mechanics</h3>
    <p>Encourage clients to track service history and future maintenance tasks.</p>
  </article>
  <article>
    <h3>Surveyors</h3>
    <p>Point owners toward a system for acting on findings and records.</p>
  </article>
  <article>
    <h3>Marine electricians</h3>
    <p>Help customers document electrical work and maintenance follow-ups.</p>
  </article>
  <article>
    <h3>Boat equipment shops</h3>
    <p>Pair equipment sales with reminders, documentation, and care routines.</p>
  </article>
  <article>
    <h3>Sailing YouTubers</h3>
    <p>Monetize educational content with a useful software recommendation.</p>
  </article>
  <article>
    <h3>Bloggers</h3>
    <p>Add YachtApp to maintenance guides, reviews, and ownership checklists.</p>
  </article>
  <article>
    <h3>Instagram creators</h3>
    <p>Share simple QR or link-in-bio campaigns with visual boating audiences.</p>
  </article>
  <article>
    <h3>Facebook communities</h3>
    <p>Give members an organized answer to recurring maintenance questions.</p>
  </article>
  <article>
    <h3>Sailing clubs</h3>
    <p>Help members standardize ownership routines and club education.</p>
  </article>
</section>